export default "__VITE_ASSET__jiQ9XiOK__"